class ClientStatusResponse {
    constructor({
                    id,
                    idServicing,
                    number,
                    label,
                    name,
                    completed,
                    beforePeoples
                }) {
        this.id = id
        this.idServicing = idServicing
        this.number = number
        this.label = label
        this.name = name
        this.completed = completed
        this.beforePeoples = beforePeoples
    }

    getId() {
        return this.id
    }

    getIdServicing() {
        return this.idServicing
    }

    getNumber() {
        return this.number
    }

    getLabel() {
        return this.label
    }

    getName() {
        return this.name
    }

    getCompleted() {
        return this.completed
    }

    getBeforePeoples() {
        return this.beforePeoples
    }
}

export default ClientStatusResponse
